/*
* Попап с содержимым
* Показываем по щедчку на кнопку
* Содержимое берется из разметки
* Существуют следующие попапы:
* - как добавлять в избранное
* - socialMarvell
*
* */


var showPopup = function(el){
	var param = JSON.parse(el.getAttribute('data-param')),
        name = param.name,
        cls = param.cls || 'popup-middle',
		btnAll = document.querySelectorAll('[data-'+ name +'-popupBtn]'),
        show = function(e){
	        if(e) e.preventDefault();
            uPopup.closeAll();
            uPopup({
                addClass:cls,
                name:name,
                content: el
            });
        },
		addEvent = function(){
			for(var i= 0,j=btnAll.length; i<j; i++){
                btnAll[i].addEventListener('click', show);
			}
        },
        checkHash = function(){
            if(location.hash === '#!' + name) show();
        },
        returnObj = {
	        show: show
        };

    //
    addEvent();
    checkHash();
    return returnObj;
}
export {showPopup};










